// Import model
import { AiAssistantCondition } from '../models/AiAssistantCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { AiAssistantIndexedFields } from '../models/AiAssistantIndexedFields';
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';

// Import dependency serializers (for complex types)
import { AiAssistantIndexedFieldsSerializer } from './AiAssistantIndexedFieldsSerializer';
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for AiAssistantCondition - handles JSON serialization and deserialization with type validation
 */
export class AiAssistantConditionSerializer {
  /**
   * Deserializes a JSON string into a AiAssistantCondition instance
   */
  static deserialize(json: string): AiAssistantCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a AiAssistantCondition instance
   */
  static fromObject(obj: any): AiAssistantCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to AiAssistantCondition');
    }


    const instance: AiAssistantCondition = {
      fieldName: obj['fieldName'] as AiAssistantIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of AiAssistantCondition instances
   */
  static deserializeArray(json: string): AiAssistantCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a AiAssistantCondition instance to a JSON string
   */
  static serialize(instance: AiAssistantCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a AiAssistantCondition instance to a plain object
   */
  static toObject(instance: AiAssistantCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of AiAssistantCondition instances to a JSON string
   */
  static serializeArray(instances: AiAssistantCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
